'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$7() {
  this.bHz = null;
  this.bHx = null;
  this.bHy = false;
  this.bHv = null;
  this.bHw = false;
  this.bHA = false;
  this.bHB = false;
  this.bHz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$7 as $c_Lpresto_TwoFactorAuthView$$anon$7 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$7;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$7() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$7 as $h_Lpresto_TwoFactorAuthView$$anon$7 };
$h_Lpresto_TwoFactorAuthView$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bHz;
});
$p.t = (function() {
  if ((!this.bHy)) {
    this.bHx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bHy = true;
  }
  return this.bHx;
});
$p.ag = (function() {
  if ((!this.bHw)) {
    this.bHv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bHw = true;
  }
  return this.bHv;
});
$p.v = (function() {
  if ((!this.bHB)) {
    this.bHA = false;
    this.bHB = true;
  }
  return this.bHA;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$7, "presto.TwoFactorAuthView$$anon$7", ({
  Ti: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$7 as $d_Lpresto_TwoFactorAuthView$$anon$7 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$7.js.map
